<script setup>
import {
	shallowRef,
	computed,
	onMounted,
} from 'vue'
import { mdiCircleSmall } from '@mdi/js'

const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const getLHS = computed(() => {
	return props.modelValue ? props.modelValue.split('.')[0] : '0'
})

const getRHS = computed(() => {
	return props.modelValue ? props.modelValue.split('.')[1] : '0'
})

const updateLHS = (val) => {
	const rhs = props.modelValue ? props.modelValue.split('.')[1] : '0'
	emit('update:modelValue', `${val}.${rhs}`)
}

const updateRHS = (val) => {
	const lhs = props.modelValue ? props.modelValue.split('.')[0] : '0'
	emit('update:modelValue', `${lhs}.${val}`)
}

const options = shallowRef(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'])

onMounted(() => {
	if (props.field.max) {
		const newOptions = []

		for (let i = 0; i <= parseInt(props.field.max); i++) {
			newOptions.push(`${i}`)
		}

		options.value = newOptions
	}
})
</script>

<template>
<div>
	<div class="d-flex">
		<v-select
			label="Tread"
			:items="options"
			:model-value="getLHS"
			hide-details="auto"
			@update:model-value="updateLHS"
		/>
		<v-icon
			:icon="mdiCircleSmall"
			class="mt-auto"
		/>
		<v-select
			label="Depth"
			:items="['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']"
			:model-value="getRHS"
			hide-details="auto"
			@update:model-value="updateRHS"
		/>
		<strong class="mt-auto ms-1">mm</strong>
	</div>
</div>
</template>

<style scoped>
:deep(.v-field__append-inner) {
    display: none;
}
</style>